import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PictionJS from 'piction-js';
import { List } from 'immutable';
import { useEffect, useRef } from 'react';

import piction from '../../utils/piction';
import { setIndex } from '../../actions/umoCarousel';
import { setMetaUmoId } from '../../actions/mainUI';
import UMOThumbnail from '../UMOThumbnail';

const mapStateToProps = (state) => ({
  umoCarousel: new Map(state.umoCarousel),
  mainUI: new Map(state.mainUI),
});

const mapDispatchToProps = (dispatch) => ({
  setIndex: (index) => dispatch(setIndex(index)),
  setMetaUmoId: (id) => dispatch(setMetaUmoId(id)),
  dispatch: (actionToDispatch) => dispatch(actionToDispatch),
});

// todo: refactor. remove isNotJustified, use classNameModifier -- i.e. same as workspace preview
function UMOCarouselReel({
  umoList,
  umoCarousel,
  setIndex,
  setMetaUmoId,
  mainUI,
}) {
  const reelRef = useRef(null);
  const activeItemRef = useRef(null);

  const umoItems = [];
  const currentIndex = umoCarousel.get('currentIndex');

  /**
   * useEffect hook responsible to Scroll active item 
   * into view when currentIndex changes
   */
  useEffect(() => {
    if (activeItemRef.current && reelRef.current) {
      const reelContainer = reelRef.current;
      const activeItem = activeItemRef.current;

      const reelRect = reelContainer.getBoundingClientRect();
      const itemRect = activeItem.getBoundingClientRect();

      const scrollLeft =
        activeItem.offsetLeft - reelRect.width / 2 + itemRect.width / 2;

      reelContainer.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });
    }
  }, [currentIndex]);

  const onReelItemClick = (index, id) => {
    setIndex(index);
    // setMetaUmoId(id); // Commented to disable the meta data trigger in carousel view
  };

  for (let i = 0; i < umoList.size; i += 1) {
    const tempUMO = new PictionJS.UMO(umoList.get(i).toJS(), {
      hostURL: piction.hostURL,
    });
    if (i === currentIndex && mainUI.get('isMetaPanelShown'))
      setMetaUmoId(tempUMO.id);
    const className = `img-reel${currentIndex == i ? ' active' : ''}`;

    // Adding ref to the active item
    const itemRef = currentIndex === i ? activeItemRef : null;

    umoItems.push(
      <div
        ref={itemRef}
        className={className}
        key={tempUMO.id}
        onClick={() => {
          onReelItemClick(i, tempUMO.id);
        }}
      >
        <UMOThumbnail umo={tempUMO} />
      </div>
    );
  }

  return (
    <div ref={reelRef} className="reel">
      {umoItems}
    </div>
  );
}

UMOCarouselReel.propTypes = {
  umoList: PropTypes.instanceOf(List),
  umoCarousel: PropTypes.instanceOf(Map),
  setIndex: PropTypes.func,
  setMetaUmoId: PropTypes.func,
  mainUI: PropTypes.instanceOf(Map),
};

export default connect(mapStateToProps, mapDispatchToProps)(UMOCarouselReel);
